var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BulkActionMenu',{attrs:{"actions":_vm.actions},scopedSlots:_vm._u([{key:"allocate",fn:function({ hide }){return [_c('Allocate',{attrs:{"module-name":_vm.moduleName},on:{"handle-allocate-action":_vm.handleAllocateAction,"trigger":hide}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }